import CourseLessonsPage from './CourseLessonsPage'
export default CourseLessonsPage;